import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_OPEN_CAMPAIGN_SERVER } from '@/app/module/campaigns/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

type SetCampaignOpenPayload = {
  campaignId: number
  open: boolean
}

export const useSetCampaignOpen = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [setOpen, res] = esApi.endpoints.setCampaignOpen.useMutation()

  const setCampaignOpen = useCallback(
    async ({ campaignId, open }: SetCampaignOpenPayload) => {
      try {
        await setOpen({
          orgId: String(orgId),
          campaignId: String(campaignId),
          body: { open },
        }).unwrap()

        return { id: Number(campaignId), open }
      } catch (error) {
        dispatch(
          createNotification({
            'open-campaign': {
              type: 'error',
              message: getErrorMessage(error, ERROR_OPEN_CAMPAIGN_SERVER),
            },
          }),
        )
        return undefined
      }
    },
    [orgId, dispatch, setOpen],
  )

  return [setCampaignOpen, res] as const
}
